import { pick } from 'lodash';
import { mixpanel } from '@fiverr-private/obs';
import store from '../../store';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';

export const reportBriefSubmitted = () => {
    const briefPayload = store.brief.getData();

    const briefCustomPayload = pick(briefPayload, [
        MIXPANEL_EVENT_PROPERTIES.BRAND_NAME,
        MIXPANEL_EVENT_PROPERTIES.INDUSTRY,
        MIXPANEL_EVENT_PROPERTIES.INDUSTRY_COUNT,
    ]);

    const payload = {
        ...briefCustomPayload,
        ...store.searchQuery.getData(),
        ...store.user.getData(),
        ...store.listingsType.getData(),
    };

    mixpanel.track('Logo Maker - MPI Brief - Brief Submitted', payload);
};
